// extracted by mini-css-extract-plugin
module.exports = {"md":"catalog-tabbar-item_md_2b8uD","ios":"catalog-tabbar-item_ios_34-yc","link":"catalog-tabbar-item_link_zVifw","delivery":"catalog-tabbar-item_delivery_EYUo4"};